module.exports = __webpack_public_path__ + "static/media/tick.5a100dcb.svg";